import { keys, each, extend, filter } from 'lodash';

/** module that contains helper functions for offer sections/services
 * @module bookingSectionService */

const serviceTypes = {
  additional: function (list) { organizeData('additionalServices', list); },
  fluid: function (list) { organizeData('fluids', list); },
  fixed: function (list) { organizeData('fixed', list); },
  lacquer: function (list) { organizeData('lacquer', list); },
  maintenance: function (list) { organizeData('maintenance', list); },
  part: function (list) { organizeData('part', list); },
  repair: function (list) { organizeData('repair', list); },
  surcharge: function (list) { organizeData('surcharge', list); },
  work: function (list) { organizeData('work', list); }
};
let serviceBreakdown = {};

/** break down offer sections (with services) into a map of service types and matching services
 * @param {Object[]} sections of an offer (with services, prices, units etc)
 * @returns {Object}
 */
const breakdown = function (sections) {
  serviceBreakdown = {
    additionalServices: { displayName: 'booking.serviceBreakdown.options' },
    fixed: { displayName: 'booking.serviceBreakdown.fixed' },
    fluids: { displayName: 'booking.serviceBreakdown.fluids' },
    lacquer: { displayName: 'booking.serviceBreakdown.lacquer' },
    maintenance: { displayName: 'booking.serviceBreakdown.maintenance' },
    part: { displayName: 'booking.serviceBreakdown.part' },
    repair: { displayName: 'booking.serviceBreakdown.repair' },
    surcharge: { displayName: 'booking.serviceBreakdown.surcharge' },
    work: { displayName: 'booking.serviceBreakdown.labor' }
  };

  if (sections) {
    let positionTypeSections = sortByPositionType(sections.sections);
    if (sections.surcharges) {
      positionTypeSections.surcharge = {
        positions: sections.surcharges,
        regularNetRate: 0
      };
      each(positionTypeSections.surcharge.positions, function (surcharge) {
        surcharge.accurate = true;
        surcharge.selected = true;
        surcharge.actualNetRate = surcharge.actualSurchargeNetRate;
        positionTypeSections.surcharge.regularNetRate += surcharge.actualSurchargeNetRate;// TODO: distinguish adding regular or actual value?
      });
    }

    each(keys(positionTypeSections), function (type) {
      serviceTypes[type](positionTypeSections[type]);
    });
  }

  return serviceBreakdown;
}

/** copy properties from the first service to section object. Mutates a section object
 * @param {Object[]} sections of an offer (with services, prices, units etc)
 * @returns undefined
 */
const flattenServices = function (sections) {
  each(sections, function (section) {
    let services = section.services;
    if (services && services[0]) {
      let service = services[0];
      extend(section, service);
    }
  });
}

/** break down offer sections (with services) into a map of position types and matching service positions
 * @param {Object[]} sections of an offer (with services, prices, units etc)
 * @returns {Object}
 */
function sortByPositionType(sections) {
  let serviceTypeSections = {};

  each(filter(sections, 'selected'), function (section) {
    let selected = section.selected;
    let serviceId = section.serviceId;

    each(section.positions, function (position) {
      let type = position.type.toLowerCase();
      if (!serviceTypeSections[type]) {
        serviceTypeSections[type] = {
          positions: [],
          regularNetRate: 0
        };
      }
      let positionTypeObj = serviceTypeSections[type];

      position.selected = selected;
      position.serviceId = serviceId;

      if (position.selected) {
        positionTypeObj.regularNetRate += position.regularNetRate;
      }

      positionTypeObj.positions.push(position);
    });
  });

  return serviceTypeSections;
}

/** add positions to service section, check if the section price and position prices are accurate
 * Mutates the section object
 * @param {String} section service type name
 * @param {Object} list positions for a service type
 * @returns undefined
 */
function organizeData(section, list) {
  serviceBreakdown[section].list = list;
  serviceBreakdown[section].accurate = true;
  each(serviceBreakdown[section].list.positions, function (position) {
    if (!position.accurate) {
      serviceBreakdown[section].accurate = false;
    }
    // TODO: check if suffix changes for each part
    position.suffixTranslationKey = 'booking.serviceBreakdown.suffix';
  });
}

/** return array of selected service ids
 * @param {Object[]} sections section with services
 * @returns {String[]}
 */
function getSelectedServiceIds(sections) {
  return filter(sections, s => s.selected).map(s => s.serviceId);
}

export default {
  flattenServices,
  breakdown,
  getSelectedServiceIds
}
